/** 列舉付款方式 */
enum PaymentType {
  UNSPECIFIED = 0,
  TAPPAY = 1,
  PAYMENTS91APP = 2,
  NEWEBPAY = 3,
}

export default PaymentType
